import { SettingsPermissions } from "@redotech/account-common/permissions";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { settingsPagePermission } from "@redotech/redo-merchant-app-common/routing/settings-page-permission";
import { breadcrumbSlot } from "@redotech/redo-web/breadcrumb";
import {
  TranslatedBreadcrumbLabel,
  TranslatedBreadcrumbLayout,
} from "../../return/returns-breadcrumb-label";

const conversionBreadcrumb = breadcrumbSlot();
const customJsBreadcrumb = breadcrumbSlot();
const tryFirstBreadcrumb = breadcrumbSlot();
const cartOptimizationBreadcrumb = breadcrumbSlot();
const generalBreadcrumb = breadcrumbSlot();

export const conversionRoutes: PermissionedRouteObject = {
  element: (
    <TranslatedBreadcrumbLayout
      breadcrumb={conversionBreadcrumb}
      getLabel={(t) =>
        t("Conversion", {
          context: "settings sidebar section for checkout conversion tools",
        })
      }
    />
  ),
  handle: {
    breadcrumb: conversionBreadcrumb,
    breadcrumbNavigate: false,
    permission: [
      SettingsPermissions.SET_TNPL_SETTINGS,
      SettingsPermissions.SET_CHECKOUT_OPTIMIZATION_SETTINGS,
    ],
  },
  path: "conversion",
  children: [
    {
      path: "custom-js",
      handle: {
        breadcrumb: customJsBreadcrumb,
        permission: SettingsPermissions.SET_CHECKOUT_OPTIMIZATION_SETTINGS,
      },
      lazy: async () => {
        const { CustomJsSettingsPage } =
          await import("./custom-js/custom-js-settings-page");
        return {
          element: (
            <>
              <TranslatedBreadcrumbLabel
                breadcrumb={customJsBreadcrumb}
                getLabel={(t) => t("Custom JavaScript")}
              />
              <CustomJsSettingsPage />
            </>
          ),
        };
      },
    },
    {
      element: (
        <TranslatedBreadcrumbLayout
          breadcrumb={tryFirstBreadcrumb}
          getLabel={(t) => t("Try first")}
        />
      ),
      handle: {
        breadcrumb: tryFirstBreadcrumb,
        breadcrumbNavigate: false,
        permission: SettingsPermissions.SET_TNPL_SETTINGS,
      },
      path: "try-first",
      children: [
        {
          index: true,
          lazy: async () => {
            const { TryFirstPage } = await import("./try-first/try-first");
            return { Component: TryFirstPage };
          },
        },
        {
          handle: {
            breadcrumb: cartOptimizationBreadcrumb,
            breadcrumbNavigate: false,
            permission: SettingsPermissions.SET_TNPL_SETTINGS,
          },
          path: "cart-optimization",
          lazy: async () => {
            const { CartOptimizationPage } =
              await import("./cart-optimization/cart-optimization");
            return {
              element: (
                <>
                  <TranslatedBreadcrumbLabel
                    breadcrumb={cartOptimizationBreadcrumb}
                    getLabel={(t) => t("Cart optimization")}
                  />
                  <CartOptimizationPage />
                </>
              ),
            };
          },
        },
      ],
    },
    {
      element: (
        <TranslatedBreadcrumbLayout
          breadcrumb={generalBreadcrumb}
          getLabel={(t) =>
            t("General", {
              context:
                "merchant settings label for general checkout conversion configuration",
            })
          }
        />
      ),
      path: "general",
      handle: {
        breadcrumb: generalBreadcrumb,
        permission: settingsPagePermission("conversion/general"),
      },
      children: [
        {
          index: true,
          lazy: async () => {
            const { ConversionGeneralSettingsPage } =
              await import("./general/conversion-general-settings-page");
            return { Component: ConversionGeneralSettingsPage };
          },
        },
      ],
    },
  ],
};
